import { TimeInMilliseconds } from '@malou-io/package-utils';

import { RequestLocalStorageKey } from ':shared/enums';

export interface LimitsAndTime {
    limit: number;
    time: number;
}

export const LIMITS_AND_TIME_BY_LOCAL_KEY: Record<RequestLocalStorageKey, LimitsAndTime> = {
    [RequestLocalStorageKey.SEARCH_REQUEST]: {
        limit: 15,
        time: TimeInMilliseconds.MINUTE,
    },
    [RequestLocalStorageKey.GET_PLACE_DETAILS_REQUEST]: {
        limit: 10,
        time: TimeInMilliseconds.HOUR,
    },
    [RequestLocalStorageKey.GET_PLACE_DIAGNOSTIC_REQUEST]: {
        limit: 3,
        time: TimeInMilliseconds.DAY,
    },
};
